export default __webpack_public_path__ + "media/images/carousel/12-811e144e121845279a0cb2c28b5e5299.jpg";